import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import NaturalImg from '../assets/images/natural-diamonds.webp'
import labImg from '../assets/images/lab-grown-diamonds.webp'
import Heading from '../ui/Heading'
import { Link } from 'react-router-dom/cjs/react-router-dom'

const NaturalLabDiamonds = () => {
    return (
        <div className='natural_lab_diamond_section'>
            <Container className='showcase-container'>
                <Row>
                    <Col sm={12} md={6} lg={6}>
                        <div className='natural_lab_diamond_inner_box'>
                            <div className='Natural_img_box_outer'> 
                            <Image src={NaturalImg} alt='Natural Image' className='img-fluid' />
                            </div>
                            <Heading className='pb-2  text-md-left text-lg-left text-sm-center text-center'>
                                <h2>Natural Diamonds </h2>
                            </Heading>
                            <div className=" text-md-left text-lg-left text-sm-center text-center">
                                <Link to="/diamonds" className="btn outline-base-btn large ">
                                    Shop Now
                                </Link>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={6}>
                        <div className='natural_lab_diamond_inner_box'>
                            <div className='Natural_img_box_outer'> 
                            <Image src={labImg} alt='Natural Image' className='img-fluid' />
                            </div>
                            <Heading className='pb-2 text-md-left text-lg-left text-sm-center text-center'>
                                <h2>Lab Grown Diamonds </h2>
                            </Heading>
                            <div className="text-md-left text-lg-left text-sm-center text-center">
                                <Link to="/diamonds/lab" className="btn outline-base-btn large ">
                                    Shop Now
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default NaturalLabDiamonds